
import React, { useState, useEffect, useRef } from "react";
import { Button } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import searchIcon from "../assets/Lupa.png";
import FormModal from "./FormModal";
import HeaderAccordionInstalacion from "./HeaderAccordionInstalacion.js";
import logo from "../assets/logo.png";
import hamburger from "../hamburger.svg";
import close from "../close.svg";
import wpcMenu from "../assets/WPC_MENU.jpg";
import spcMenu from "../assets/SPC_MENU.jpg";
import lvtMenu from "../assets/FOREST NOGAL.webp";
import deckMenu from "../assets/deck caramel ambiente.webp";
import PanelesMenu from "../assets/Ambiente Gloom.webp";
import arrow from "../assets/arrow.png";
import "./Header.css";

function Header({ scrollToSection, catalogosection, instalacionsection }) {
  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState("");
  const [input, setInput] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [megaMenuBtn, setMegaMenuBtn] = useState("op1");
  const [megaMenuBtnCol3, setMegaMenuBtnCol3] = useState("op1-op1");
  const [navBg, setNavBg] = useState(false);

  // Estados específicos para controlar los acordeones móviles
  const [mobileActiveCategory, setMobileActiveCategory] = useState(null); 
  const [mobileWpcSubtype, setMobileWpcSubtype] = useState(null); 

  const navigate = useNavigate();
  const headerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    const changeNavBg = () => {
      setNavBg(window.scrollY >= 70);
    };

    document.addEventListener("click", handleClickOutside);
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", changeNavBg);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", changeNavBg);
    };
  }, []);

  const onCloseModal = () => {
    setOpenModal(false);
    setEmail("");
  };

  const handleInput = (event) => {
    setInput(event.target.value);
  };

  const handleKeyUp = (event) => {
    if (event.key === "Enter" && input.trim() !== "") {
      navigate(`/search/${input}`);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMegamenu = (btn) => {
    setMegaMenuBtn(btn);
    setMegaMenuBtnCol3(`img-${btn}`);
  };

  const handleMegamenuCol3 = (btn) => {
    setMegaMenuBtnCol3(btn);
  };

  const handleMenuSelection = async (section) => {
    if (window.location.pathname !== "/") {
      await navigate("/");
    }
    setIsMenuOpen(false);
    scrollToSection(section);
  };

  const toggleMobileCategory = (op) => {
    if (mobileActiveCategory === op) {
      setMobileActiveCategory(null);
      setMobileWpcSubtype(null);
    } else {
      setMobileActiveCategory(op);
      setMobileWpcSubtype(null);
    }
  };

  return (
    <>
      {isMobile ? (
        <header ref={headerRef} className={`mobile-header-wrapper ${isMenuOpen ? "expanded-header" : ""} ${navBg ? "header-nav-color" : ""}`}>
          <div className="mobile-top-bar">
            <a href="/">
              <img src={logo} className="logo" alt="logo" />
            </a>

            <div className="search-container">
            <input
              type="search"
              className="search-input"
              id="site-search"
              value={input}
              onChange={handleInput}
              onKeyUp={handleKeyUp}
              placeholder="Buscar..."
            />
            <a href={input ? `/search/${input}` : "#"}>
              <img className="lupaIcon" src={searchIcon} alt="lupa" />
            </a>
          </div>

            <button className="hamburger-icon" onClick={toggleMenu} aria-label="Menú">
              <img src={isMenuOpen ? close : hamburger} alt="menu-toggle" />
            </button>
          </div>

       

          {isMenuOpen && (
            <section className="header-container mobile-dropdown-menu">
              <div className="additional-text">
                
                {/* PRODUCTOS WPC */}
                <div className="mobile-nav-group">
                  <div className="mobile-accordion-header" onClick={() => toggleMobileCategory("op1")}>
                    <span>Productos WPC</span>
                    <img src={arrow} className={`arrow-indicator ${mobileActiveCategory === "op1" ? "rotated" : ""}`} alt="arrow" />
                  </div>
                  {mobileActiveCategory === "op1" && (
                    <div className="mobile-submenu-content">
                      <a href="/categoria/wpc" className="mobile-main-link">Ver todo WPC</a>
                      <div className="mobile-subtypes">
                        
                        {/* Submenú Interiores con flecha acordeón */}
                        <div 
                          className="mobile-accordion-header" 
                          onClick={() => setMobileWpcSubtype(mobileWpcSubtype === "interior" ? null : "interior")}
                        >
                          <span>Interiores</span>
                          <img 
                            src={arrow} 
                            className={`arrow-indicator ${mobileWpcSubtype === "interior" ? "rotated" : ""}`} 
                            alt="arrow" 
                          />
                        </div>

                        {mobileWpcSubtype === "interior" && (
                          <div className="mobile-deep-list">
                            <span className="col-title">Colecciones</span>
                            <a href="/categoria/wpc/quattro">Quattro</a>
                            <a href="/categoria/wpc/Quattro%20Colores%20Puros">Quattro Colores Puros</a>
                            <a href="/categoria/wpc/sette">Sette</a>
                            <a href="/categoria/wpc/Tre%20Pianni">Tre Pianni</a>
                            <a href="/categoria/wpc/Scala">Scala</a>
                            <span className="col-title">Paneles Vigas Esquineros</span>
                            <a href="/categoria/wpc/panel%20contour">Panel Contour</a>
                            <a href="/categoria/wpc/panel%20liso">Panel Liso</a>
                            <a href="/categoria/wpc/panel%20biselado">Panel Biselado</a>
                            <a href="/categoria/wpc/vigas">Vigas</a>
                            <a href="/categoria/wpc/esquineros">Esquineros</a>
                            <a href="/categoria/wpc/Iluminación%20y%20Colocación">Iluminación y Colocación</a>
                          </div>
                        )}

                        {/* Submenú Exteriores con flecha acordeón */}
                        <div 
                          className="mobile-accordion-header" 
                          onClick={() => setMobileWpcSubtype(mobileWpcSubtype === "exterior" ? null : "exterior")}
                        >
                          <span>Exteriores</span>
                          <img 
                            src={arrow} 
                            className={`arrow-indicator ${mobileWpcSubtype === "exterior" ? "rotated" : ""}`} 
                            alt="arrow" 
                          />
                        </div>

                        {mobileWpcSubtype === "exterior" && (
                          <div className="mobile-deep-list">
                            <a href="/categoria/wpc/Panel%20Liso%20Exterior">Panel Liso Exterior</a>
                            <a href="/categoria/wpc/Quattro%20Exterior">Quattro Exterior</a>
                            <a href="/categoria/wpc/Five%20Exterior">Five Exterior</a>
                            <a href="/categoria/wpc/Vigas%20Exterior">Vigas</a>
                            <a href="/categoria/wpc/Colocación%20Exteriores">Colocación Exteriores</a>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* SPC */}
                <div className="mobile-nav-group">
                  <div className="mobile-accordion-header" onClick={() => toggleMobileCategory("op2")}>
                    <span>Productos SPC</span>
                    <img src={arrow} className={`arrow-indicator ${mobileActiveCategory === "op2" ? "rotated" : ""}`} alt="arrow" />
                  </div>
                  {mobileActiveCategory === "op2" && (
                    <div className="mobile-submenu-content">
                      <a href="/categoria/spc" className="mobile-main-link">Ver todo SPC</a>
                      <span className="col-title">Colecciones Interiores</span>
                      <a href="/categoria/spc/Tenon">Tenon</a>
                      <a href="/categoria/spc/Douglas">Douglas</a>
                      <a href="/categoria/spc/Lawson">Lawson</a>
                      <a href="/categoria/spc/Palm">Palm</a>
                      <a href="/categoria/spc/Zoclo%20SPC">Zoclo SPC</a>
                      <a href="/categoria/spc/Colocación%20SPC">Colocación</a>
                    </div>
                  )}
                </div>

                {/* LVT */}
                <div className="mobile-nav-group">
                  <div className="mobile-accordion-header" onClick={() => toggleMobileCategory("op3")}>
                    <span>Productos LVT</span>
                    <img src={arrow} className={`arrow-indicator ${mobileActiveCategory === "op3" ? "rotated" : ""}`} alt="arrow" />
                  </div>
                  {mobileActiveCategory === "op3" && (
                    <div className="mobile-submenu-content">
                      <a href="/categoria/lvt" className="mobile-main-link">Ver todo LVT</a>
                      <span className="col-title">Colecciones Interiores</span>
                      <a href="/categoria/lvt/forest">Forest</a>
                      <a href="/categoria/lvt/Concrete">Concrete</a>
                      <a href="/categoria/lvt/Ozz">OZZ</a>
                    </div>
                  )}
                </div>

                {/* PANELES DECORATIVOS */}
                <div className="mobile-nav-group">
                  <a href="/categoria/Paneles%20Decorativos" className="mobile-standalone-link">
                    Paneles Decorativos
                  </a>
                </div>

                {/* DECK EXTERIORES */}
                <div className="mobile-nav-group">
                  <div className="mobile-accordion-header" onClick={() => toggleMobileCategory("op4")}>
                    <span>Deck Exteriores</span>
                    <img src={arrow} className={`arrow-indicator ${mobileActiveCategory === "op4" ? "rotated" : ""}`} alt="arrow" />
                  </div>
                  {mobileActiveCategory === "op4" && (
                    <div className="mobile-submenu-content">
                      <a href="/categoria/Deck/Deck%20Bicolor">Deck Bicolor</a>
                      <a href="/categoria/Deck">Deck</a>
                      <a href="/categoria/Deck/Accesorios">Accesorios</a>
                    </div>
                  )}
                </div>

                <button className="link-header-mobile" onClick={() => handleMenuSelection(catalogosection)}>
                  Catálogo
                </button>

                <HeaderAccordionInstalacion handleMenuSelection={handleMenuSelection} instalacionsection={instalacionsection} />

                <Button className="link-header-mobile header-button" onClick={() => setOpenModal(true)}>
                  Quiero comprar
                </Button>
                <FormModal openModal={openModal} onCloseModal={onCloseModal} email={email} setEmail={setEmail} />
              </div>
            </section>
          )}
        </header>
      ) : (
        // DESKTOP
        <header className={navBg ? "header-nav-color" : ""} ref={headerRef}>
          <a href="/">
            <img src={logo} className="logo" alt="logo" />
          </a>
          <nav className="header-nav">
            <div
              className="dropdown"
              onMouseLeave={() => handleMegamenu("op1")}
            >
              <a className="dropbtn header-btn-productos" href="/productos" >
                Productos
                <img src={arrow} />
              </a>
              <div className="dropdown-content">
                <ul className="dropdown-categories">
                  <a
                    href="/categoria/wpc"
                    className={megaMenuBtn === "op1" ? "il-selected" : ""}
                    onMouseEnter={() => handleMegamenu("op1")}
                  >
                    <span>WPC</span>
                    <span className="menu-subtitle">Wood-Plastic Composite</span>
                  </a>
                  <a
                    href="/categoria/spc"
                    className={megaMenuBtn === "op2" ? "il-selected" : ""}
                    onMouseEnter={() => handleMegamenu("op2")}
                  >
                    <span>SPC</span>
                    <span className="menu-subtitle">Pisos Vinílicos Multicapa</span>
                  </a>
                  <a
                    href="/categoria/lvt"
                    className={megaMenuBtn === "op3" ? "il-selected" : ""}
                    onMouseEnter={() => handleMegamenu("op3")}
                  >
                    <span>LVT</span>
                    <span className="menu-subtitle">Pisos Vinílicos de Alta Calidad</span>
                  </a>

                  <a
                    href="/categoria/Paneles%20Decorativos"
                    className={megaMenuBtn === "op5" ? "il-selected" : ""}
                    onMouseEnter={() => handleMegamenu("op5")}
                  >
                    <span>Paneles Decorativos</span>
                  </a>

                  <a
                    href="/categoria/Deck"
                    className={megaMenuBtn === "op4" ? "il-selected" : ""}
                    onMouseEnter={() => handleMegamenu("op4")}
                  >
                    <span>Deck Exteriores</span>
                  </a>

                </ul>
                {megaMenuBtn === "op1" && (
                  <>
                    <ul className="col1">
                      <a href="/categoria/wpc/interior"
                        onMouseEnter={() => handleMegamenuCol3("op1-op1")}>Interiores</a>
                      <a href="/categoria/wpc/exterior"
                        onMouseEnter={() => handleMegamenuCol3("op1-op2")}>Exteriores</a>
                    </ul>
                  </>
                )}
                {megaMenuBtnCol3 === "img-op1" && (
                  <>
                    <ul className="col-img">
                      <img
                        className="menu-img"
                        src={wpcMenu}
                        alt="spc-menu-img"
                      />
                    </ul>
                  </>
                )}
                {megaMenuBtnCol3 === "op1-op1" && (
                  <>
                    <ul className="col2">
                      <span className="col-title">Colecciones</span>
                      <a href="/categoria/wpc/quattro">Quattro</a>
                      <a href="/categoria/wpc/Quattro%20Colores%20Puros">Quattro Colores Puros</a>
                      <a href="/categoria/wpc/sette">Sette</a>
                      <a href="/categoria/wpc/Tre%20Pianni">Tre Pianni</a>
                      <a href="/categoria/wpc/Scala">Scala</a>
                    </ul>

                    <ul className="col3">
                      <span className="col-title">Paneles Vigas Esquineros</span>
                      <a href="/categoria/wpc/panel%20contour">Panel Contour</a>
                      <a href="/categoria/wpc/panel%20liso">Panel Liso</a>
                      <a href="/categoria/wpc/panel%20biselado">Panel Biselado</a>
                      <a href="/categoria/wpc/vigas">Vigas</a>
                      <a href="/categoria/wpc/esquineros">Esquineros</a>
                      <a href="/categoria/wpc/Iluminación%20y%20Colocación">Iluminación y Colocación</a>
                    </ul>
                  </>
                )}
                {megaMenuBtnCol3 === "op1-op2" && (
                  <>
                    <ul className="col2">
                      <a href="/categoria/wpc/Panel%20Liso%20Exterior">Panel Liso Exterior</a>
                      <a href="/categoria/wpc/Quattro%20Exterior">Quattro Exterior</a>
                      <a href="/categoria/wpc/Five%20Exterior">Five Exterior</a>
                      <a href="/categoria/wpc/Vigas%20Exterior">Vigas</a>
                      <a href="/categoria/wpc/Colocación%20Exteriores">Colocación Exteriores</a>
                    </ul>
                  </>
                )}
                {megaMenuBtn === "op2" && (
                  <>
                    <ul className="col1">
                      <span className="col-title">Colecciones Interiores</span>
                      <a href="/categoria/spc/Tenon">Tenon</a>
                      <a href="/categoria/spc/Douglas">Douglas</a>
                      <a href="/categoria/spc/Lawson">Lawson</a>
                      <a href="/categoria/spc/Palm">Palm</a>
                      <a href="/categoria/spc/Zoclo%20SPC">Zoclo SPC</a>
                      <a href="/categoria/spc/Colocación%20SPC">Colocación</a>
                    </ul>
                  </>
                )}
                {megaMenuBtnCol3 === "img-op2" && (
                  <>
                    <ul className="col-img">
                      <img
                        className="menu-img"
                        src={spcMenu}
                        alt="spc-menu-img"
                      />
                    </ul>
                  </>
                )}
                {megaMenuBtn === "op3" && (
                  <>
                    <ul className="col1">
                      <span className="col-title">Colecciones Interiores</span>
                      <a href="/categoria/lvt/forest">Forest</a>
                      <a href="/categoria/lvt/Concrete">Concrete</a>
                      <a href="/categoria/lvt/Ozz">OZZ</a>
                    </ul>
                  </>
                )}
                {megaMenuBtnCol3 === "img-op3" && (
                  <>
                    <ul className="col-img">
                      <img
                        className="menu-img"
                        src={lvtMenu}
                        alt="spc-menu-img"
                      />
                    </ul>
                  </>
                )}
                {megaMenuBtn === "op4" && (
                  <>
                    <ul className="col1">
                      <a href="/categoria/Deck/Deck%20Bicolor">Deck Bicolor</a>
                      <a href="/categoria/Deck">Deck</a>
                      <a href="/categoria/Deck/Accesorios">Accesorios</a>
                    </ul>
                  </>
                )}
                {megaMenuBtnCol3 === "img-op4" && (
                  <>
                    <ul className="col-img">
                      <img
                        className="menu-img"
                        src={deckMenu}
                        alt="spc-menu-img"
                      />
                    </ul>
                  </>
                )}
                {megaMenuBtnCol3 === "img-op5" && (
                  <>
                    <ul className="col-img">
                      <img
                        className="menu-img"
                        src={PanelesMenu}
                        alt="spc-menu-img"
                      />
                    </ul>
                  </>
                )}
              </div>
            </div>

            <button className="header-btn-catalogo" onClick={() => handleMenuSelection(catalogosection)}>
              Catálogo
            </button>

            <button className="header-btn-catalogo"> Instalación <img src={arrow} alt="arrow" />
              <div className="dropdown">
                <a href="/manuales">Manuales</a>
                <button onClick={() => handleMenuSelection(instalacionsection)}>Videos de Instalación</button>
              </div>
            </button>

            <Button className="header-button" onClick={() => setOpenModal(true)}>Quiero comprar</Button>

            <div className="search-container">
              <input
                type="search"
                className="search-input"
                id="site-search"
                value={input}
                onChange={handleInput}
                onKeyUp={handleKeyUp}
                placeholder="¿Qué estás buscando?"
              />
              <a href={input ? `/search/${input}` : "#"}>
                <img className="lupaIcon" src={searchIcon} alt="lupa" />
              </a>
            </div>

            <FormModal openModal={openModal} onCloseModal={onCloseModal} email={email} setEmail={setEmail} />
          </nav>
        </header>
      )}
    </>
  );
}

export default Header;
